/**
 * 排出事業者データ補完
 * 削除
 */
import Vue from "vue";
import * as httpConst from "@/constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/transfers/removes`;

const getDefaultState = () => {
  return {}
}

const transferRemove = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    /**
     * 削除処理を行う
     * @param commit
     * @param params {Object} 排出事業者情報
     * @param params.jwnet_manifest_ids {Array} JWNETマニフェスト_ID
     */
    update ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.patch(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(content)
        } )
      })
    },

  }
}

export default transferRemove;
